import {
   hasMeaningfulCalendarEventColor,
   normalizeColorToCss,
   pickUserProfileColor,
} from "./extremeEventColors";

export function getReservationId(row) {
   return (
      row?.id ??
      row?._id ??
      row?.reservationId ??
      row?.reservation_id ??
      row?.reservation?.id ??
      null
   );
}

function getReservationBaseInstructorId(row) {
   return (
      row?.instructorId ??
      row?.instructor_id ??
      row?.instructor?.id ??
      row?.reservation?.instructorId ??
      row?.reservation?.instructor_id ??
      row?.reservation?.instructor?.id ??
      null
   );
}

export function getReservationEffectiveInstructorId(row) {
   const effectiveId =
      row?.effectiveInstructor?.id ??
      row?.effective_instructor?.id ??
      row?.reservation?.effectiveInstructor?.id ??
      row?.reservation?.effective_instructor?.id ??
      null;
   if (effectiveId !== null && effectiveId !== undefined && effectiveId !== "") {
      return effectiveId;
   }

   if (hasReservationSubstitution(row)) {
      const substitution =
         row?.substitution ??
         row?.reservation?.substitution ??
         row?.instructorSubstitution ??
         row?.reservation?.instructorSubstitution ??
         null;
      const substituteId =
         substitution?.substituteInstructorId ??
         substitution?.substitute_instructor_id ??
         null;
      if (substituteId !== null && substituteId !== undefined && substituteId !== "") {
         return substituteId;
      }
   }

   return getReservationBaseInstructorId(row);
}

function getReservationSubstitutionBaseInstructorId(row) {
   const substitution =
      row?.substitution ??
      row?.reservation?.substitution ??
      row?.instructorSubstitution ??
      row?.reservation?.instructorSubstitution ??
      null;
   if (!substitution) return null;
   if (substitution?.isActive === false || substitution?.is_active === false) {
      return null;
   }
   const baseId =
      substitution?.baseInstructorId ??
      substitution?.base_instructor_id ??
      substitution?.baseInstructor?.id ??
      substitution?.base_instructor?.id ??
      null;
   if (baseId == null || baseId === "") return null;
   return baseId;
}

export function getReservationColumnInstructorId(row) {
   const substitutionBaseId = getReservationSubstitutionBaseInstructorId(row);
   if (substitutionBaseId != null && substitutionBaseId !== "") {
      return substitutionBaseId;
   }
   return getReservationBaseInstructorId(row);
}

export function hasReservationSubstitution(row) {
   const substitution =
      row?.substitution ??
      row?.reservation?.substitution ??
      row?.instructorSubstitution ??
      row?.reservation?.instructorSubstitution ??
      null;
   if (!substitution) return false;
   if (substitution?.isActive === false || substitution?.is_active === false) {
      return false;
   }
   return true;
}

export function getReservationStartRaw(row) {
   return (
      row?.startTime ??
      row?.start ??
      row?.start_time ??
      row?.startDate ??
      row?.start_date ??
      row?.dateTime ??
      row?.datetime ??
      row?.date ??
      row?.begin ??
      row?.from ??
      row?.startedAt ??
      row?.reservation?.startTime ??
      row?.reservation?.start ??
      row?.reservation?.start_time ??
      row?.reservation?.startDate ??
      row?.reservation?.start_date ??
      row?.reservation?.dateTime ??
      row?.reservation?.datetime ??
      row?.reservation?.date ??
      row?.reservation?.begin ??
      row?.reservation?.from ??
      row?.reservation?.startedAt ??
      null
   );
}

export function getReservationStudentId(row) {
   return (
      row?.studentId ??
      row?.student_id ??
      row?.userId ??
      row?.user_id ??
      row?.student?.id ??
      row?.user?.id ??
      row?.reservation?.studentId ??
      row?.reservation?.student_id ??
      row?.reservation?.userId ??
      row?.reservation?.user_id ??
      row?.reservation?.student?.id ??
      row?.reservation?.user?.id ??
      null
   );
}

export function getPersonFullName(person) {
   const first = String(
      person?.firstName ?? person?.firstname ?? person?.name ?? "",
   ).trim();
   const last = String(person?.lastName ?? person?.lastname ?? "").trim();
   const full = `${first} ${last}`.trim();
   return full || "";
}

export function getPersonPhone(person) {
   return String(
      person?.phone ??
         person?.phoneNumber ??
         person?.mobile ??
         person?.telefon ??
         person?.tel ??
         "",
   ).trim();
}

export function getPersonPrivateMessage(person) {
   return String(
      person?.privateMessage ?? person?.privateMessaje ?? person?.note ?? "",
   ).trim();
}

export function getPersonDesiredInstructorId(person) {
   return String(
      person?.desiredInstructorId ?? person?.desiredInstructor?.id ?? "",
   ).trim();
}

export function composeReservationAndProfileNote(reservationNote, profileNote) {
   const reservationText = String(reservationNote || "").trim();
   const profileText = String(profileNote || "").trim();
   if (reservationText && profileText) {
      if (reservationText === profileText) return reservationText;
      const reservationSegments = reservationText
         .split(/\s*;\s*|\n+/)
         .map((segment) => String(segment || "").trim().toLowerCase())
         .filter(Boolean);
      const profileSegment = profileText.toLowerCase();
      if (reservationSegments.includes(profileSegment)) return reservationText;
      return `${reservationText}; ${profileText}`;
   }
   return reservationText || profileText;
}

function toBoolFlag(value) {
   if (value === true) return true;
   if (value === false) return false;
   if (typeof value === "number") return value === 1;
   const text = String(value || "").trim().toLowerCase();
   if (!text) return false;
   return text === "1" || text === "true" || text === "yes" || text === "da";
}

export function resolveGearboxBadge(value) {
   const text = String(value || "").trim();
   if (!text) return "";
   const lower = text.toLowerCase();
   if (lower === "a" || lower.includes("auto") || lower.includes("automat")) {
      return "A";
   }
   if (lower === "m" || lower.includes("manual")) return "M";
   return text.slice(0, 2).toUpperCase();
}

export function getReservationPrivateMessage(row) {
   return String(
      row?.privateMessage ??
         row?.privateMessaje ??
         row?.eventPrivateMessage ??
         row?.comment ??
         row?.notes ??
         row?.reservation?.privateMessage ??
         row?.reservation?.privateMessaje ??
         row?.reservation?.eventPrivateMessage ??
         row?.reservation?.comment ??
         row?.reservation?.notes ??
         "",
   ).trim();
}

export function getReservationSector(row) {
   return String(
      row?.sector ?? row?.reservation?.sector ?? row?.location ?? "",
   ).trim();
}

export function getReservationGearbox(row) {
   return String(
      row?.gearboxLabel ??
         row?.gearbox ??
         row?.reservation?.gearboxLabel ??
         row?.reservation?.gearbox ??
         "",
   ).trim();
}

export function getReservationPhone(row) {
   return String(
      row?.phoneNumber ??
         row?.phone ??
         row?.reservation?.phoneNumber ??
         row?.reservation?.phone ??
         "",
   ).trim();
}

export function getReservationColor(row, person = null) {
   const pickColorFromCharacteristics = (source) => {
      if (!source || typeof source !== "object") return null;

      const direct =
         source?.characteristic?.color ??
         source?.characteristics?.color ??
         source?.reservation?.characteristic?.color ??
         source?.reservation?.characteristics?.color ??
         null;
      if (direct != null) {
         const text = String(direct).trim();
         if (text) return text;
      }

      const candidates = [
         source?.characteristics,
         source?.characteristic,
         source?.reservation?.characteristics,
         source?.reservation?.characteristic,
      ];
      for (const list of candidates) {
         if (!Array.isArray(list)) continue;
         for (const item of list) {
            const raw =
               item?.color ??
               item?.colorToken ??
               item?.eventColor ??
               item?.value ??
               item?.label ??
               null;
            const text = String(raw ?? "").trim();
            if (!text) continue;
            if (
               text.startsWith("--") ||
               text.startsWith("var(") ||
               text.startsWith("#") ||
               /^(rgba?|hsla?)\(/i.test(text) ||
               /(event|red|orange|yellow|green|blue|indigo|purple|pink)/i.test(text)
            ) {
               return text;
            }
         }
      }

      return null;
   };

   const reservationColor =
      row?.color ??
      row?.colorToken ??
      row?.eventColor ??
      row?.reservation?.color ??
      row?.reservation?.colorToken ??
      row?.reservation?.eventColor ??
      pickColorFromCharacteristics(row) ??
      null;
   if (hasMeaningfulCalendarEventColor(reservationColor)) {
      return normalizeColorToCss(reservationColor);
   }

   const studentProfileColor = pickUserProfileColor(person);
   if (hasMeaningfulCalendarEventColor(studentProfileColor)) {
      return normalizeColorToCss(studentProfileColor);
   }

   const reservationUserColor = pickUserProfileColor(
      row?.user || row?.reservation?.user || null,
   );
   if (hasMeaningfulCalendarEventColor(reservationUserColor)) {
      return normalizeColorToCss(reservationUserColor);
   }
   return normalizeColorToCss("--event-default");
}

export function getReservationTags(row) {
   const rawTags =
      row?.tags ??
      row?.reservation?.tags ??
      row?.tag ??
      row?.reservation?.tag ??
      [];
   const source = Array.isArray(rawTags)
      ? rawTags
      : typeof rawTags === "string"
         ? rawTags.split(",")
         : [rawTags];

   return source
      .map((item) => {
         if (item == null) return "";
         if (typeof item === "string") return item.trim();
         if (typeof item === "number") return String(item);
         if (typeof item === "object") {
            return String(
               item?.label ?? item?.name ?? item?.text ?? item?.value ?? "",
            ).trim();
         }
         return "";
      })
      .filter(Boolean)
      .map((tag) => {
         const normalized = String(tag).trim().toLowerCase();
         return normalized === "schimb" ? "§" : tag;
      });
}

export function getReservationIsFavorite(row) {
   return toBoolFlag(
      row?.isFavorite ??
         row?.is_favorite ??
         row?.reservation?.isFavorite ??
         row?.reservation?.is_favorite ??
         row?.raw?.isFavorite ??
         row?.raw?.is_favorite,
   );
}

export function getReservationIsImportant(row) {
   return toBoolFlag(
      row?.isImportant ??
         row?.is_important ??
         row?.reservation?.isImportant ??
         row?.reservation?.is_important ??
         row?.raw?.isImportant ??
         row?.raw?.is_important,
   );
}

export function getReservationIsCanceled(row) {
   const byFlag = toBoolFlag(
      row?.isCanceled ??
         row?.isCancelled ??
         row?.is_cancelled ??
         row?.reservation?.isCanceled ??
         row?.reservation?.isCancelled ??
         row?.reservation?.is_cancelled,
   );
   if (byFlag) return true;
   const action = String(
      row?.status ??
         row?.action ??
         row?.type ??
         row?.reservation?.status ??
         row?.reservation?.action ??
         row?.reservation?.type ??
         "",
   ).toLowerCase();
   return /cancel|anulat|canceled|cancelled/.test(action);
}

export function hasActiveReservationInSlot(items) {
   if (!Array.isArray(items) || !items.length) return false;
   for (const item of items) {
      if (item && item.isCanceled !== true) return true;
   }
   return false;
}
